import { useEffect, useState } from 'react';
import { Options } from '@/components/Common/Selects/Select.types';
import { DisciplineWithLessonsInput } from '@/hooks/useConfigExam';
import { UseFormSetValue } from 'react-hook-form';

interface LessonDataItem {
  discipline: { _id: string; name: string };
  lessons: Options[];
}

interface UseDisciplineLessonPrefillProps {
  editingDiscipline?: {
    index: number;
    data: DisciplineWithLessonsInput;
  } | null;
  disciplines?: Options[];
  lessonsData?: LessonDataItem[];
  setValue: UseFormSetValue<DisciplineWithLessonsInput>;
}

export function useDisciplineLessonPrefill({
  editingDiscipline,
  disciplines,
  lessonsData,
  setValue,
}: UseDisciplineLessonPrefillProps) {
  const [selectedDiscipline, setSelectedDiscipline] = useState<Options | null>(
    null,
  );
  const [selectedLessons, setSelectedLessons] = useState<Options[]>([]);

  // Discipline
  useEffect(() => {
    if (editingDiscipline) {
      const discipline = editingDiscipline.data.discipline;
      if (typeof discipline === 'string') {
        const foundDiscipline = disciplines?.find((d) => d._id === discipline);
        if (foundDiscipline) {
          setSelectedDiscipline(foundDiscipline);
        }
      } else {
        setSelectedDiscipline(discipline);
      }
      setValue(
        'discipline',
        discipline as DisciplineWithLessonsInput['discipline'],
      );
    }
  }, [editingDiscipline, disciplines, setValue]);

  // Lessons
  useEffect(() => {
    if (editingDiscipline && selectedDiscipline) {
      const disciplineId =
        typeof selectedDiscipline === 'string'
          ? selectedDiscipline
          : selectedDiscipline._id;

      const lessonsOptions =
        lessonsData?.find((item) => item.discipline._id === disciplineId)
          ?.lessons || [];

      const selected = lessonsOptions.filter((option: Options) =>
        editingDiscipline.data.lessons.some(
          (sel: Options) => sel._id === option._id,
        ),
      );
      setSelectedLessons(selected);
      setValue('lessons', selected as DisciplineWithLessonsInput['lessons']);
    }
  }, [editingDiscipline, lessonsData, selectedDiscipline, setValue]);

  return {
    selectedDiscipline,
    setSelectedDiscipline,
    selectedLessons,
    setSelectedLessons,
  };
}
